import { ParamIds, Places } from '../../../Constants'
import { MainKeys } from '../../../main/Main.keys'

export class UserManagerKeys extends MainKeys {
    get place() {
        return Places.userManager
    }

    get userFilter() {
        return this._intent.getParameterAsString(ParamIds.userFilter)
    }

    set userFilter(value: string | undefined) {
        this._intent.setParameter(ParamIds.userFilter, value)
    }
}

export default UserManagerKeys
